import * as React from 'react'
import { Switch, Route } from 'react-router-dom'

import PasswordRecoveryContainer from './passwordRecoveryContainer'
import ResetPasswordContainer from './resetPasswordContainer'
import ThankYouContainer from './thankYouContainer'

const PasswordRecovery = () => {
	const NoMatch = (): any => {
		window.location.href = '/users/login'
		return null
	}

	return (
		<Switch>
			<Route exact path="/users/passwordRecovery" component={PasswordRecoveryContainer} />
			<Route exact path="/users/passwordRecovery/reset/:token" component={ResetPasswordContainer} />
			<Route path="/users/passwordRecovery/thankyou/:username" component={ThankYouContainer} />
			<Route component={NoMatch} />
		</Switch>
	)
}

export default PasswordRecovery
//render(<Root />, document.querySelector('#root'))
